import { render, staticRenderFns } from "./ProductEditPage.vue?vue&type=template&id=350560da&"
import script from "./ProductEditPage.vue?vue&type=script&lang=ts&"
export * from "./ProductEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports